export const getters = {
  getModalViewTransaction: state => state.modalViewTransaction,
  getTransactions: state => state.transactions,
  getTransaction: state => state.transaction,
  get_reports: state => state.reports,
};

export default {};
